module.exports = __webpack_public_path__ + "img/cover.666f9cd2.jpg";